import script from "./AtomAccordionTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./AtomAccordionTable.vue?vue&type=script&lang=ts&setup=true"

import "./AtomAccordionTable.vue?vue&type=style&index=0&id=758adc41&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-758adc41"]])

export default __exports__